export default __webpack_public_path__ + "maps-overview-symbol-layer-1200-3550159e84f903082d8a18dd82160522.webp";